import React, { Component } from "react";
import config from "lib/fr-config";
import PropTypes from "prop-types";
import CommonImageView from "presentational/common/CommonImageView";

const RATIO = config.outfitImage.RATIO;

class OutfitImageView extends Component {
  static propTypes = {
    imageSrc: PropTypes.string,
    increaseZIndex: PropTypes.bool,
    removeGlass: PropTypes.bool
  };

  static defaultProps = {
    imageSrc: null,
    increaseZIndex: false,
    removeGlass: false
  };

  render() {
    const { imageSrc, increaseZIndex, removeGlass } = this.props;

    return (
      <CommonImageView
        imageSrc={imageSrc || "pending"}
        imageRatio={RATIO}
        increaseZIndex={increaseZIndex}
        removeGlass={removeGlass}
      />
    );
  }
}

export default OutfitImageView;
